import { render, staticRenderFns } from "./PatientVerification.vue?vue&type=template&id=3139dd10&scoped=true"
import script from "./PatientVerification.vue?vue&type=script&lang=js"
export * from "./PatientVerification.vue?vue&type=script&lang=js"
import style0 from "./PatientVerification.vue?vue&type=style&index=0&id=3139dd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139dd10",
  null
  
)

export default component.exports